import { useState, useEffect, useCallback, useMemo } from "react";
import { fetchUnits, deleteUnit } from "../services/unitService";
import { getLowerCaseString } from "../helpers/function";
import { verifyTokenExpire } from "../middleware/verifyToken";

export const useUnits = (endPoint) => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);

  const loadUnits = useCallback(async () => {
    if (!verifyTokenExpire()) return;

    setLoading(true);
    try {
      const data = await fetchUnits(endPoint, currentPage, perPage, searchTerm);
      setUnits(data.data);      
      setTotalItems(data.total);
      setTotalPages(data.last_page);
      setPrevUrl(data.prev_page_url);
      setNextUrl(data.next_page_url);
    } catch (error) {
      console.error("Error fetching units:", error);
    } finally {
      setLoading(false);
    }
  }, [endPoint, searchTerm, perPage, currentPage]);

  const nextPage = (e) => {
    e.preventDefault();
    if (currentPage <= totalPages && nextUrl !== null) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = (e) => {
    e.preventDefault();
    if (currentPage >= 1 && prevUrl !== null) {
      setCurrentPage(currentPage - 1);
    }
  };


  useEffect(() => {
    setCurrentPage(1);
  }, [ searchTerm]);

  const changeItemsPerPage = (value) => {
    setCurrentPage(1);
    setPerPage(parseInt(value))
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    loadUnits();
  }, [loadUnits]);

  const filteredUnits = useMemo(() => {
    return units
  }, [units]);


  const removeUnit = useCallback(
    async (unitId) => {
      if (!verifyTokenExpire()) return false;
      try {
        await deleteUnit(endPoint, unitId);
        setUnits((prevUnits) => prevUnits.filter((unit) => unit.id !== unitId));
        return true;
      } catch (error) {
        console.error("Error deleting unit:", error);
        return false;
      }
    },
    [endPoint]
  );

  return {
    units,
    filteredUnits,
    loading,
    searchTerm,
    setSearchTerm,
    removeUnit,
    refresh: loadUnits,
    currentPage,
    perPage,
    totalPages,
    totalItems,
    prevPage,
    nextPage,
    goToPage,
    changeItemsPerPage,
  };
};
